import clsx from 'clsx'
import styled from 'styled-components'
import { rem } from 'polished'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'

const Price = styled.div`
  display: grid;
  align-content: start;
  gap: ${rem(8)};
  min-height: ${rem(144)};
  min-width: 0;

  &.compact { min-height: ${rem(52)}; }

  @media (prefers-reduced-motion: reduce) {
    *::after { animation: none; }
  }
`

/** Reserves price/disclosure space without presenting an old quote as current. */
function AccommodationPackagePriceSkeleton({ compact = false }: { compact?: boolean }) {
  return <Price className={clsx({ compact })} aria-hidden="true" data-testid="package-price-skeleton">
    {!compact && <TextLoadingBox typography="caption-medium" width="55%" />}
    <TextLoadingBox typography="heading4" width="70%" />
    {!compact && <TextLoadingBox typography="caption-medium" width="85%" />}
    <TextLoadingBox typography="caption-small" width="65%" />
  </Price>
}

export default AccommodationPackagePriceSkeleton
